<a id="logo" class="text-black" routerLink="/"><h1 class="display-3 ml-5">Meme Creator</h1></a>
<router-outlet></router-outlet>